<template>
  <div>
    <el-row>
      <el-col :span="1">
        <el-button style="color: white" @click="back">返回稿件列表</el-button>
      </el-col>
      <el-col :span="2" :offset="18">
        <el-button style="color: white" @click="reSubmit()"
          >提交新版本</el-button
        >
      </el-col>
      <el-col :span="2" :offset="1">
        <el-button style="color: white" @click="contributorCancelTheDelivery()"
          >撤销投递</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col class="content">
        <div class="mydoc">
          <div class="header" style="font-weight: 900"><i></i>稿件信息</div>
          <div class="mybody">
            <el-descriptions border :column="1">
              <el-descriptions-item label="稿件标题">{{
                manuscripts.newest.manuscript.title
              }}</el-descriptions-item>
              <el-descriptions-item label="稿件编号"
                >SYYYX-{{ time }}</el-descriptions-item
              >
              <el-descriptions-item label="作者信息">
                <span
                  v-for="(item, index) in manuscripts.newest.manuscript
                    .authorInfo"
                  :key="index"
                >
                  {{
                    item.name +
                    "  [" +
                    "联系电话：" +
                    item.phone +
                    "," +
                    "邮箱：" +
                    item.email +
                    "," +
                    "所属单位：" +
                    item.unit +
                    "]"
                  }}
                  <br />
                </span>
              </el-descriptions-item>

              <el-descriptions-item label="摘要">
                <p>
                  {{ manuscripts.newest.manuscript.abstracts }}
                </p></el-descriptions-item
              >
              <el-descriptions-item label="关键词：">
                {{ manuscripts.newest.manuscript.manuscriptKeywords }}
              </el-descriptions-item>
              <el-descriptions-item label="下载">
                <el-button
                  type="primary"
                  style="background-color: #fd7f48"
                  @click="downloadZip(getZipUrl(manuscripts.newest.manuscript))"
                  >下载</el-button
                >
                <el-button
                  type="primary"
                  @click="contentShow = true"
                  style="background-color: #fd7f48; margin-left: 10px"
                  >点击预览</el-button
                >
                <el-dialog
                  :title="manuscripts.newest.manuscript.title"
                  :visible.sync="contentShow"
                  fullscreen
                >
                  <div style="height: 85vh; width: 100%">
                    <iframe
                      :src="
                        'https://www.exp-linguistics.net/file_preview/onlinePreview?url=' +
                        getPdfBase64(manuscripts.newest.manuscript)
                      "
                      frameborder="none"
                      width="100%"
                      height="100%"
                    ></iframe>
                  </div>
                </el-dialog>
              </el-descriptions-item>
              <el-descriptions-item label="提交日期">
                {{ manuscripts.newest.manuscript.deliveryTime.substr(0, 10) }}
              </el-descriptions-item>
              <el-descriptions-item label="历史记录">
                <el-button
                  type="primary"
                  style="background-color: #fd7f48"
                  @click="historyShow = true"
                  >查看投递历史</el-button
                >
                <el-dialog
                  :title="'稿件历史版本'"
                  :visible.sync="historyShow"
                  fullscreen
                >
                  <el-row class="content">
                    <div class="mydoc">
                      <el-row
                        v-for="(
                          historyItem, historyIndex
                        ) in manuscripts.history"
                        :key="historyIndex"
                      >
                        <div class="mybody">
                          <div class="header" style="font-weight: 900">
                            版本{{ historyIndex + 1 }}:
                          </div>

                          <el-descriptions border :column="1">
                            <el-descriptions-item label="稿件标题">{{
                              historyItem.manuscript.title
                            }}</el-descriptions-item>
                            <el-descriptions-item label="稿件编号"
                              >SYYYX-{{
                                historyItem.manuscript.manuscriptId
                              }}</el-descriptions-item
                            >
                            <el-descriptions-item label="摘要">
                              <p>
                                {{ historyItem.manuscript.abstracts }}
                              </p></el-descriptions-item
                            >
                            <el-descriptions-item label="关键词：">
                              {{ historyItem.manuscript.manuscriptKeywords }}
                            </el-descriptions-item>
                            <el-descriptions-item label="下载">
                              <el-button
                                type="primary"
                                @click="
                                  downloadZip(getZipUrl(historyItem.manuscript))
                                "
                                >下载</el-button
                              >
                            </el-descriptions-item>
                            <el-descriptions-item label="提交日期">
                              {{
                                historyItem.manuscript.deliveryTime.substr(
                                  0,
                                  10
                                )
                              }}
                            </el-descriptions-item>
                          </el-descriptions>
                          <br />
                          <el-row>
                            <el-divider content-position="center"
                              ><h2>责任编辑初审</h2></el-divider
                            >

                            <el-col
                              :span="24"
                              v-if="
                                historyItem.charge.manuscriptStatus !=
                                'unreviewed'
                              "
                            >
                              <el-col>
                                <br />
                                <el-alert
                                  v-if="
                                    historyItem.manuscript.manuscriptStatus ==
                                    'refuse'
                                  "
                                  type="error"
                                  :closable="false"
                                >
                                  责任编辑初审状态: 已驳回
                                </el-alert>
                                <el-alert
                                  v-else
                                  type="success"
                                  :closable="false"
                                >
                                  责任编辑初审状态: 已通过
                                </el-alert>
                                <el-descriptions border :column="1">
                                  <el-descriptions-item label="审核意见"
                                    >{{ historyItem.charge.auditOpinion }}
                                  </el-descriptions-item>
                                  <el-descriptions-item label="审核日期">
                                    {{
                                      historyItem.charge.modificationTime
                                    }}</el-descriptions-item
                                  >
                                </el-descriptions>
                                <br />
                                <br />
                              </el-col>
                            </el-col>
                          </el-row>
                          <el-row
                            v-if="
                              historyItem.charge.manuscriptStatus != 'refuse'
                            "
                          >
                            <br />
                            <br />
                            <el-divider content-position="center"
                              ><h2>审稿人评审</h2></el-divider
                            >

                            <el-col
                              v-for="(item, index) in historyItem.reviewers"
                              :key="index"
                            >
                              <template v-if="item.visible != 'hidden'">
                                <el-alert type="info" :closable="false">
                                  审稿人审核状态:

                                  <el-tag
                                    v-if="item.manuscriptStatus == 'success'"
                                    type="success"
                                    >通过</el-tag
                                  >
                                  <el-tag
                                    v-if="item.manuscriptStatus == 'refuse'"
                                    type="error"
                                    >驳回</el-tag
                                  >
                                </el-alert>
                                <el-descriptions border :column="3">
                                  <el-descriptions-item
                                    label="审稿人次序"
                                    :span="3"
                                  >
                                    审稿人{{ index + 1 }}号
                                  </el-descriptions-item>

                                  <template>
                                    <el-descriptions-item
                                      label="审核意见"
                                      :span="3"
                                    >
                                      <p>
                                        {{ item.auditOpinion }}
                                      </p>
                                    </el-descriptions-item>

                                    <el-descriptions-item label="选题方面">{{
                                      item.topicValue
                                    }}</el-descriptions-item>
                                    <el-descriptions-item label="理论意义">{{
                                      item.theoryValue
                                    }}</el-descriptions-item>
                                    <el-descriptions-item label="应用价值">
                                      <p>
                                        {{ item.useValue }}
                                      </p></el-descriptions-item
                                    >
                                    <el-descriptions-item label="创新性">
                                      {{ item.creativeValue }}
                                    </el-descriptions-item>

                                    <el-descriptions-item label="分析方法">{{
                                      item.analyzeValue
                                    }}</el-descriptions-item>
                                    <el-descriptions-item label="研究结论">{{
                                      item.studyValue
                                    }}</el-descriptions-item>
                                    <el-descriptions-item label="学术水平">
                                      <p>
                                        {{ item.academicValue }}
                                      </p></el-descriptions-item
                                    >
                                    <el-descriptions-item label="总体评价">
                                      {{ item.aboveValue }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="审稿结论：">
                                      <el-select
                                        disabled
                                        v-model="item.manuscriptStatus"
                                        placeholder="请选择"
                                      >
                                        <el-option
                                          label="可以发表 "
                                          value="success"
                                        >
                                        </el-option>
                                        <el-option
                                          label="改后发表 "
                                          value="fixed_publish"
                                        >
                                        </el-option>
                                        <el-option
                                          label="改后重审"
                                          value="fixed_review"
                                        >
                                        </el-option>
                                        <el-option
                                          label="不宜发表"
                                          value="refuse"
                                        >
                                        </el-option>
                                      </el-select>
                                    </el-descriptions-item>
                                  </template>
                                </el-descriptions>

                                <br />
                                <br />
                              </template>
                            </el-col>
                            <br />
                            <br />
                          </el-row>
                          <el-row>
                            <template
                              v-if="
                                historyItem.manuscript.manuscriptStatus ==
                                  'second_refuse' ||
                                historyItem.manuscript.manuscriptStatus ==
                                  'success'
                              "
                            >
                              <el-col>
                                <el-divider content-position="center"
                                  ><h2>责任编辑最终意见</h2></el-divider
                                >
                                <br />
                                <br />
                                <el-alert type="info" :closable="false">
                                  审核状态:
                                  <el-tag
                                    type="success"
                                    v-if="
                                      historyItem.manuscript.manuscriptStatus ==
                                      'success'
                                    "
                                    >通过</el-tag
                                  >
                                  <el-tag type="danger" v-else>驳回</el-tag>
                                </el-alert>
                                <el-descriptions border :column="1">
                                  <el-descriptions-item label="最终意见">
                                    {{ historyItem.charge.secondAuditOpinion }}
                                  </el-descriptions-item>
                                </el-descriptions>
                              </el-col>
                            </template>
                          </el-row>
                        </div>
                      </el-row>
                    </div>
                  </el-row>
                </el-dialog>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </el-col>
    </el-row>
    <br />
    <br />

    <el-row class="content">
      <div class="mydoc">
        <div class="header" style="font-weight: 900">审核意见</div>
        <div class="mybody">
          <el-row>
            <el-divider content-position="center"
              ><h2>责任编辑初审</h2></el-divider
            >
            <br />
            <br />

            <el-col :span="24" v-if="chargeManuscriptStatus == 'refuse'">
              <br />
              <el-alert type="error" :closable="false">
                责任编辑初审状态: 已驳回
              </el-alert>
              <el-descriptions border :column="1">
                <el-descriptions-item label="审核意见"
                  >{{ manuscripts.newest.charge.auditOpinion }}
                </el-descriptions-item>
                <el-descriptions-item label="审核日期">
                  {{
                    manuscripts.newest.charge.modificationTime
                  }}</el-descriptions-item
                >
              </el-descriptions>
            </el-col>
            <el-col :span="24" v-if="chargeManuscriptStatus == 'unreviewed'">
              <br />
              <el-alert type="info" :closable="false">
                责任编辑初审状态: 未审核
              </el-alert>
              <el-empty
                :image-size="60"
                description="责任编辑未审核稿件，暂无数据"
              ></el-empty>
            </el-col>
            <el-col
              v-if="
                chargeManuscriptStatus != 'unreviewed' &&
                chargeManuscriptStatus != 'refuse'
              "
            >
              <br />
              <el-alert type="success" :closable="false">
                责任编辑初审状态: 已通过
              </el-alert>
              <el-descriptions border :column="1">
                <el-descriptions-item label="审核意见"
                  >{{ manuscripts.newest.charge.auditOpinion }}
                </el-descriptions-item>
                <el-descriptions-item label="审核日期">
                  {{
                    manuscripts.newest.charge.modificationTime
                  }}</el-descriptions-item
                >
              </el-descriptions>
            </el-col>
          </el-row>
          <el-row v-if="chargeManuscriptStatus == 'success'">
            <br />
            <el-divider content-position="center"
              ><h2>审稿人评审</h2></el-divider
            >
            <br />
            <br />
            <el-col
              v-for="(item, index) in manuscripts.newest.reviewers"
              :key="index"
            >
              <template v-if="item.visible != 'hidden'">
                <el-alert type="info" :closable="false">
                  审稿人审核状态:
                  <el-tag
                    v-if="item.manuscriptStatus == 'unreviewed'"
                    type="warning"
                    >未审核</el-tag
                  >
                  <el-tag
                    v-else-if="item.manuscriptStatus == 'success'"
                    type="success"
                    >通过</el-tag
                  >
                  <el-tag v-else type="error">驳回</el-tag>
                </el-alert>
                <el-descriptions border :column="3">
                  <el-descriptions-item label="审稿人次序" :span="3">
                    审稿人{{ index + 1 }}号
                  </el-descriptions-item>

                  <el-descriptions-item
                    label="审核内容"
                    :span="3"
                    v-if="item.manuscriptStatus == 'unreviewed'"
                  >
                    <el-empty
                      :image-size="60"
                      description="审稿人未审核，暂无数据"
                    ></el-empty>
                  </el-descriptions-item>
                  <template v-else>
                    <el-descriptions-item label="审核意见" :span="3">
                      <p>{{ item.auditOpinion }}</p>
                    </el-descriptions-item>

                    <el-descriptions-item label="选题方面">{{
                      item.topicValue
                    }}</el-descriptions-item>
                    <el-descriptions-item label="理论意义">{{
                      item.theoryValue
                    }}</el-descriptions-item>
                    <el-descriptions-item label="应用价值">
                      <p>{{ item.useValue }}</p></el-descriptions-item
                    >
                    <el-descriptions-item label="创新性">
                      {{ item.creativeValue }}
                    </el-descriptions-item>

                    <el-descriptions-item label="分析方法">{{
                      item.analyzeValue
                    }}</el-descriptions-item>
                    <el-descriptions-item label="研究结论">{{
                      item.studyValue
                    }}</el-descriptions-item>
                    <el-descriptions-item label="学术水平">
                      <p>{{ item.academicValue }}</p></el-descriptions-item
                    >
                    <el-descriptions-item label="总体评价">
                      {{ item.aboveValue }}
                    </el-descriptions-item>
                    <el-descriptions-item label="审稿结论：">
                      <el-select
                        disabled
                        v-model="item.manuscriptStatus"
                        placeholder="请选择"
                      >
                        <el-option label="可以发表 " value="success">
                        </el-option>
                        <el-option label="改后发表 " value="fixed_publish">
                        </el-option>
                        <el-option label="改后重审" value="fixed_review">
                        </el-option>
                        <el-option label="不宜发表" value="refuse"> </el-option>
                      </el-select>
                    </el-descriptions-item>
                  </template>
                </el-descriptions>

                <br />
                <br />
              </template>
            </el-col>
            <br />
          </el-row>
          <el-row v-else> </el-row>
          <br />
          <el-row>
            <template
              v-if="
                manuscripts.newest.charge.manuscriptStatus == 'second_refuse' ||
                manuscripts.newest.charge.manuscriptStatus == 'success'
              "
            >
              <el-col>
                <el-divider content-position="center"
                  ><h2>责任编辑最终意见</h2></el-divider
                >
                <br />
                <br />
                <el-alert style="text-align: left">
                  当前状态:<el-tag
                    type="success"
                    v-if="
                      manuscripts.newest.manuscript.manuscriptStatus ==
                      'success'
                    "
                    >通过</el-tag
                  >
                  <el-tag type="danger" v-else>驳回</el-tag>
                </el-alert>
                <el-descriptions border :column="1">
                  <el-descriptions-item label="最终意见">
                    {{ manuscripts.newest.charge.secondAuditOpinion }}
                  </el-descriptions-item>
                </el-descriptions>
              </el-col>
            </template>
          </el-row>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getManuscriptsChargeInfo, cancelTheDelivery } from '@/api/data'
export default {
  name: 'manuscriptDetail',
  components: {},
  data () {
    return {
      time: null,
      flag: null,
      historyShow: false,
      contentShow: false,
      userInfo: null,
      manuscripts: {},
      chargeManuscriptStatus: null,
      mamuscriptManuscriptStatus: null
    }
  },
  methods: {
    formatDate (date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          )
        }
      }
      return fmt
    },
    // 左边补0函数
    padLeftZero (str) {
      return ('00' + str).substr(str.length)
    },
    contributorCancelTheDelivery () {
      cancelTheDelivery({
        flag: this.flag
      }).then((res) => {
        if (res.data.result == true) {
          this.$message({
            message: '稿件撤销成功',
            type: 'success'
          })
          this.back()
        } else {
          this.$message({
            message: '稿件撤销失败',
            type: 'error'
          })
        }
      })
    },

    back () {
      const back = this
      back.$router.push({ name: 'manuscriptList' })
    },
    reSubmit () {
      console.log(
        this.manuscripts.newest.manuscript.manuscriptStatus.indexOf('refuse')
      )
      if (
        this.manuscripts.newest.manuscript.manuscriptStatus.indexOf('refuse') >=
        0
      ) {
        this.$router.push('/submitManuscript?flag=' + this.$route.query.flag)
      } else if (
        this.manuscripts.newest.manuscript.manuscriptStatus == 'success'
      ) {
        this.$message({
          message: '该稿件已审核通过，无须再提交',
          type: 'warning'
        })
      } else {
        this.$message({
          message: '该版本审核未结束，无法提交新版本',
          type: 'warning'
        })
      }
    },

    findManuscript (flag) {
      getManuscriptsChargeInfo({
        manuscriptFlag: flag
      }).then((res) => {
        console.log(res.data)
        this.manuscripts = res.data.result
        this.manuscripts.newest.manuscript.authorInfo = this.manuscripts.newest.manuscript.authorInfo.filter(item => item !== null)
        let date = new Date(this.manuscripts.newest.manuscript.manuscriptId / 1000)
        this.time = this.formatDate(date, 'yyyy-MM-dd hh:mm:ss')
        this.chargeManuscriptStatus =
          this.manuscripts.newest.charge.manuscriptStatus
        this.manuscriptManuscriptStatus =
          this.manuscripts.newest.manuscript.manuscriptStatus
      })
    },
    getPdfBase64 (item) {
      return Base64.encode(
        'http://www.exp-linguistics.net/file/' +
          JSON.parse(item.content).mainPdf
      )
    },
    getZipUrl (item) {
      return (
        'http://www.exp-linguistics.net/file/' + item.title + item.manuscriptId + '.zip'
      )
    },
    downloadZip (fileUrl) {
      window.open(fileUrl)
    }
  },
  mounted () {
    // let userInfo = this.$cookie.getCookie("userInfo");
    // if (userInfo == null || userInfo.type != "contributor") {
    //   this.$message({
    //     message: "请先登录！",
    //     type: "error",
    //   });
    //   this.$router.push("index");
    // }

    // this.userInfo = userInfo;
    this.findManuscript(this.$route.query.flag)
    this.flag = this.$route.query.flag
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 12px;

  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);

      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
button {
  background-color: #004947;
  border: none;
}
button:hover {
  background-color: #004947;
}
button:active {
  background-color: #004947;
}
</style>



// WEBPACK FOOTER //
// src/view/contributor/manuscriptDetail.vue